import { SidebarProvider } from '@src/app/layout';
import { Box } from '@src/shared/ui/layout';

import Main from './Main';
import Sidebar from './Sidebar';

function Navigation() {
  return (
    <Box component="nav">
      <Sidebar />
    </Box>
  );
}

export default function App() {
  return (
    <SidebarProvider>
      <Navigation />
      <Main />
    </SidebarProvider>
  );
}
